const cookie = {
    getCookie: function getCookie(name) {
      var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg))
        return (arr[2]);
      else
        return null;
    },
    setCookie: function setCookie(c_name, value) {
      document.cookie = c_name + "=" + escape(value) + ";path=/";
    },
    delCookie: function delCookie(name) {
      var exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval = cookie.getCookie(name);
      if (cval != null){
        document.cookie= name + "="+cval+";path=/;expires="+exp.toGMTString();
      }
    }
  }
  
  export default cookie;


// WEBPACK FOOTER //
// ./src/network/cookie.js